import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-20 px-4 bg-primary text-white" data-id="element-203">
      <div className="max-w-4xl mx-auto text-center" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white/10 backdrop-blur-md p-8 md:p-12 rounded-3xl border border-white/20" data-id="element-205">
          <h2 className="font-heading text-3xl md:text-4xl mb-8 text-accent" data-id="element-206">
            Lo que experimentarás
          </h2>

          <div className="space-y-8 text-left md:text-center" data-id="element-207">
            <div className="relative" data-id="element-208">
              <span className="block text-sage/60 font-bold text-sm uppercase tracking-wider mb-2" data-id="element-209">
                Días 1 a 3
              </span>
              <p className="text-lg md:text-xl font-medium leading-relaxed" data-id="element-210">
                Notarás que tus zapatos te quedan más holgados y que la "neblina
                mental" del mediodía desaparece. Tu cuerpo comienza a soltar el
                agua retenida.
              </p>
            </div>

            <div className="w-16 h-px bg-accent/50 mx-auto hidden md:block" data-id="element-211"></div>

            <div className="relative" data-id="element-212">
              <span className="block text-sage/60 font-bold text-sm uppercase tracking-wider mb-2" data-id="element-213">
                Día 7
              </span>
              <p className="text-lg md:text-xl font-medium leading-relaxed" data-id="element-214">
                Verás en el espejo una versión de ti misma con el abdomen
                desinflamado y la piel más clara, simplemente porque eliminaste
                los disparadores de cortisol que te mantenían hinchada.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}